define([
  'es6!sumo/util',
  'immutable',
  'underscore',
  'moment',
  'es6!launcher/actions/share/ShareActions',
], (Util, Immutable, _, moment, Actions) => {
  const initialState = Immutable.Map({
    appId: '9e8a4d2a-6f8c-415e-851b-bdfe4c01d5c1',
    appName: 'share',
    proSlug: 'share-pro',
    cartId: null,

    //  Tracks which settings have been loaded already
    loaded: Immutable.Map(),

    // Clicks View
    clickStats: Immutable.Map(),
    startDate: moment().subtract(7, 'days'),
    endDate: moment(),
    device: null,
    service: null,
    href: null,
    showFacebookDialog: false,
    facebookConnected: false,

    // Settings View
    settings: Immutable.Map(),
    positionSettings: Immutable.Map(),
    customPositionSettings: Immutable.Map(),

    // Shortener states
    shortener: Immutable.Map(),

    topPages: Immutable.List(),
  });

  const actionHandlers = {};

  actionHandlers[Actions.SHARE_UPDATE_SETTING] = (state, action) => {
    const { key, value } = action;

    if (Array.isArray(key)) return state.setIn(key, value);
    return state.set(key, value);
  };

  actionHandlers[Actions.SHARE_RECEIVE_SETTINGS] = (state, action) => {
    const { settings } = action;
    return state.mergeIn(['settings'], Immutable.fromJS(settings));
  };

  actionHandlers[Actions.SHARE_RECEIVE_POSITION_SETTINGS] = (state, action) => {
    const { position, settings } = action;
    return state.mergeIn(['positionSettings', position], Immutable.fromJS(settings));
  };

  actionHandlers[Actions.SHARE_RECEIVE_CUSTOM_POSITION_SETTINGS] = (state, action) => {
    const { settings } = action;
    return state.setIn(['customPositionSettings', settings.id || 'new'], Immutable.fromJS(settings));
  };

  actionHandlers[Actions.SHARE_RECEIVE_STATS] = (state, action) => {
    const { stats } = action;

    return state.merge(Immutable.fromJS({
      clickStats: stats,
      showFacebookDialog: stats.showFacebookDialog,
    }));
  };

  actionHandlers[Actions.SHARE_RECEIVE_SHORTENER_STATE] = (state, action) => (
    state.setIn(['shortener', action.service], Immutable.fromJS(action.state))
  );

  actionHandlers[Actions.SHARE_RECEIVE_STATE] = (state, action) => {
    const {
      notice,
      cart_id: cartId,
      req_id: reqId,
    } = action.state;

    return state.merge(Immutable.fromJS({
      notice,
      cartId,
      reqId,
    }));
  };

  return Util.createReducer(initialState, actionHandlers);
});
